import { createRequestActions } from 'store/actionCreators'

export const fetchVideos = createRequestActions('VIDEOS/GET', () => ({
  request: {
    url: '/videos',
  },
}))
